import { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { getHeadersAPI } from "../api/ServicesConfiguration";

function CallBack() {
  const navigate = useNavigate();

  //Get URL Parameters
  const queryParameters = new URLSearchParams(window.location.search);
  const status = queryParameters.get("Status");
  const packageGuid = queryParameters.get("PackageExternalReference");

  

  // FetchData
  const fetchData = async () => {
    try {
        axios.post(
            process.env.REACT_APP_BASE_API_URL + '/api/esignatures/callbackProcess/'+packageGuid+'/'+status,
        {packageGuid: packageGuid,
            status: status
        },
        {
          headers: await getHeadersAPI(packageGuid)
        })
        .then(response => {
            if(response) {


navigate(response.data)

                // if(status == "REJECT") {
                //   navigate('/ContractRejected');  
                // } else {
                //    navigate('/ContractPortal?guid='+response.data);  
                // }    
            }    
        })
        .catch(error => {
            console.error('API Error:', error);
        });
    } catch (error) {
        console.error('API Error:', error);
    }
  };

  //Run 1 time
  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div>
      <div className="over-layer">
        <i className="fas fa-4x fa-sync-alt fa-spin"></i>
      </div>
    </div>
  );
}

export default CallBack;